module.exports = __webpack_public_path__ + "img/hik.ac98163a.png";